import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { listData } from "../services/api";
import ContentTable from "../../../components/ContentTable";
import DefaultRow from "../../../components/ContentTable/defaultRow";

export default function Channels() {
  const navigate = useNavigate();
  const [channels, setChannels] = useState({
    headers: ["Name", "URL", "Channel ID", "Subscriptions", "Donations"],
    data: [],
    rows: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  // const [cursor, setCursor] = useState("");

  async function getChannelsList() {
    const { data } = await listData({
      table: "channels",
      term: "",
      value: "",
      limit: 0,
      cursor: "",
    });

    const rows = data.map((channel) => [
      channel.name,
      channel.url,
      channel.id,
      <Button
        variant="outline-primary"
        onClick={() =>
          navigate(`${channel.id}/subscriptions`, {
            state: { count: channel._count.subscriptions },
          })
        }
      >
        {" "}
        Subscriptions{" "}
      </Button>,
      <Button
        variant="outline-primary"
        onClick={() =>
          navigate(`${channel.id}/donations`, {
            state: { count: channel._count.donations },
          })
        }
      >
        {" "}
        Donations{" "}
      </Button>,
    ]);

    setChannels((prev) => ({
      ...prev,
      id: data.map((channel) => channel.id),
      rows: <DefaultRow args={rows} />,
      data: data,
      count: data.length,
    }));
    setIsLoading(false);
  }

  useEffect(() => {
    getChannelsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="w-full h-20 text-center content-center">
        <span className="w-full text-black fw-bold text-2xl tracking-widest uppercase">
          Channels
        </span>
      </div>
      <Button
        className="absolute right-10 top-20 w-20 h-10"
        onClick={() => navigate(-1)}
        variant="outline-primary"
      >
        Back
      </Button>
      {isLoading ? (
        <div className="w-full text-center py-5">
          <Spinner />
        </div>
      ) : (
        <ContentTable args={channels} />
      )}
    </>
  );
}
